export default {
  // 页面标题
  title: 'Organization Profile',
  
  // 侧边栏导航项
  navigation: {
    billingAndPayments: 'Billing & Payments',
    plan: 'Plan',
    couponCode: 'Coupon code',
    timezone: 'Timezone',
    developer: 'Developer'
  },
  
  // 权限相关消息
  permissions: {
    tenantUpgradeRequired: 'This page requires tenant upgrade',
    adminOnly: 'Only an Admin can access this content.'
  },
  
  // 页面描述
  description: 'Manage your organization settings and preferences'
};
